import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISearchResultsData } from "../../data/ChemicalSearchModel";
import { IChemicalSearchModelResult } from "../../data/ChemicalSearchModelResult";

export type SearchResultsState = {
    showModal: boolean;
    maxNumber: number;
    data: IChemicalSearchModelResult | null;
    sender: string | null;
    selectedIndexes: number[];
    selectedValues: ISearchResultsData[];
};

type ShowOptions = {
    result: IChemicalSearchModelResult;
    sender: string;
    maxNumber?: number;
};

const initialState: SearchResultsState = {
    showModal: false,
    maxNumber: 1,
    data: null,
    sender: null,
    selectedIndexes: [],
    selectedValues: [],
};

const searchResultsSlice = createSlice({
    name: "searchResults",
    initialState,
    reducers: {
        showSearchResults(state, action: PayloadAction<ShowOptions>) {
            const { result, sender, maxNumber } = action.payload;
            let models = result?.models || [];
            models = models.map((item, index) => ({
                ...item,
                ui_index: index,
            }));
            state.maxNumber = maxNumber || 1;
            state.showModal = true;
            state.data = { ...result, models };
            state.sender = sender;
            state.selectedIndexes = [];
            state.selectedValues = [];
        },
        closeSearchResults(state) {
            state.showModal = false;
        },
        clearSearchResults(state) {
            state.selectedIndexes = [];
            state.selectedValues = [];
        },
        selectSearchResults(state, action: PayloadAction<ISearchResultsData>) {
            const value = action.payload;
            const indexes = [...state.selectedIndexes];
            const values = [...state.selectedValues];
            const existingIndex = indexes.indexOf(value.ui_index);
            if (state.maxNumber === 1) {
                state.selectedIndexes = [value.ui_index];
                state.selectedValues = [value];
            } else {
                if (existingIndex >= 0) {
                    indexes.splice(existingIndex, 1);
                    values.splice(existingIndex, 1);
                } else if (values.length < state.maxNumber) {
                    indexes.push(value.ui_index);
                    values.push(value);
                }
                state.selectedIndexes = indexes;
                state.selectedValues = values;
            }
        },
        submitSearchResults(state) {
            state.showModal = false;
        },
    },
});

export const {
    showSearchResults,
    closeSearchResults,
    clearSearchResults,
    selectSearchResults,
    submitSearchResults,
} = searchResultsSlice.actions;
export default searchResultsSlice.reducer;
